(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("flex", [], factory);
	else if(typeof exports === 'object')
		exports["flex"] = factory();
	else
		root["flex"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 